import { getOrderVouchers } from './get-order-vouchers';
export const getOrderVouchersForTypeCodes = (voucherTypeCodes) => {
    return getOrderVouchers().filter(voucher => voucherTypeCodes.includes(voucher.voucherTypeCode));
};
